import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';

@Component({
  selector: 'usb-boat-item',
  templateUrl: './boat-item.component.html',
  styleUrls: ['./boat-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoatItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;

  get boat(): any {
    return this.item?.additionalInfo?.boat;
  }

  get skipperIncluded(): boolean {
    return !!this.item?.additionalInfo?.skipper?.included;
  }

  get location(): string {
    return this.item?.additionalInfo?.location || this.item?.origin || '';
  }

  // No hay coordenadas del puerto en el resultado: el mapa se abre buscando el nombre del puerto.
  get mapUrl(): string {
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(this.location);
  }
}
